import { render } from "./MatchCard.vue?vue&type=template&id=60e3b793"
import script from "./MatchCard.vue?vue&type=script&lang=js"
export * from "./MatchCard.vue?vue&type=script&lang=js"

import "./MatchCard.vue?vue&type=style&index=0&id=60e3b793&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__